"use client";

import JoinCommunityButton from "@/modules/community/components/join-community-button";
import { TCommunityInfo } from "@/types/community";
import Image from "next/image";
import HeroSectionModerators from "./moderators";
import CommunityStats from "./stats";
import VerifiedBadgeCheck from "@/components/common/verified-badge-check";
import UpcomingEvent from "../calendar/components/community-upcoming-events";

const CommunityYoutubeBanner = ({ communityInfo }: { communityInfo: TCommunityInfo }) => {
	const getYoutubeLink = () => {
		if (communityInfo.slug === "africa-valuation-conference") {
			return "https://www.youtube-nocookie.com/embed/jBuWYfYUJSg?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "women-in-proptech") {
			return "https://www.youtube-nocookie.com/embed/RMhKfb6h_bg?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "proptech-india") {
			return "https://www.youtube-nocookie.com/embed/ozJH_bBPMIA?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "proptech-austria") {
			return "https://www.youtube-nocookie.com/embed/aaK8HUmjUBk?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "proptech-germany") {
			return "https://www.youtube-nocookie.com/embed/loB-QgLk0uE?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "portugal-rei-club") {
			return "https://www.youtube-nocookie.com/embed/U-lsFabdJGc?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "global-proptech-founders") {
			return "https://www.youtube-nocookie.com/embed/WXiZXfKjO6s?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "bim-digital-twin") {
			return "https://www.youtube-nocookie.com/embed/EvneW0EGcy8?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "proptech-bangladesh") {
			return "https://www.youtube-nocookie.com/embed/Qddw2NmUGHM?autoplay=1&start=0&mute=1";
		} else if (communityInfo.slug === "latam") {
			return "https://www.youtube-nocookie.com/embed/XGWt3HRQ6-Y?autoplay=1&start=0&mute=1";
		}
		return "https://www.youtube-nocookie.com/embed/RMhKfb6h_bg?autoplay=1&start=0&mute=1";
	};
	return (
		<div className="relative">
			<div className="mb-4 mt-8 h-[580px] w-full">
				<iframe
					width="560"
					height="315"
					allowFullScreen
					src={getYoutubeLink()}
					title="PropTechBuzz Daily Digest 5"
					allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
					referrerPolicy="strict-origin-when-cross-origin"
					className="aspect-video h-full w-full"
				></iframe>
			</div>

			<div className="relative">
				<div className="flex items-end gap-5">
					<div className="absolute -top-2 left-6">
						<div className="h-fit w-fit overflow-hidden rounded-xl bg-white p-1 shadow-lg">
							<Image
								className="h-24 w-24 rounded-xl 3xl:h-32 3xl:w-32"
								src={communityInfo.logo || "/placeholder.svg"}
								alt={communityInfo.name}
								width={1080}
								height={1080}
							/>
						</div>
					</div>

					<div className="flex flex-1 items-start justify-between gap-4 pt-20 max-xl:flex-wrap md:pl-36 md:pt-4 3xl:pl-44">
						<div className="flex flex-1 items-start justify-between max-md:flex-wrap">
							<div>
								<div className="mb-1 flex flex-wrap items-center gap-2 md:gap-3">
									<h1 className="max-w-lg text-xl font-bold text-gray-900 md:text-2xl 3xl:text-3xl">
										{communityInfo.name}
									</h1>

									<VerifiedBadgeCheck iconClassName="w-6 h-6 md:w-7 md:h-7" />
								</div>

								<p
									className="hidden max-w-2xl text-sm text-gray-600 md:block 3xl:text-base"
									dangerouslySetInnerHTML={{ __html: communityInfo.description || "" }}
								/>
							</div>

							<CommunityStats
								totalPosts={communityInfo.totalPosts}
								totalMembers={communityInfo.totalMembers}
								totalViews={communityInfo.totalViews}
							/>
						</div>

						<p
							className="block text-sm text-gray-600 md:hidden"
							dangerouslySetInnerHTML={{ __html: communityInfo.description || "" }}
						/>
					</div>
				</div>

				<div className="mb-8 mt-8 flex items-center justify-between gap-2 max-md:flex-wrap 3xl:mt-6">
					<div className="w-full md:w-auto md:pl-6">
						<HeroSectionModerators moderators={communityInfo.moderators} />
					</div>

					<JoinCommunityButton communityId={communityInfo.id} />
				</div>
			</div>

			<div>
				<UpcomingEvent communitySlug={communityInfo.slug} />
			</div>
		</div>
	);
};

export default CommunityYoutubeBanner;
